// React
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'

// Components
import P from 'ui/elements/P'
import Loader from 'ui/components/Loader'
import BTimeTable from 'store/modules/product/blocks/ProductAvailabilityCalendar/TimeTable'
import Icon from 'ui/components/Icon'

// Libraries
import { withTranslation } from 'shared/utils/withTranslation'

// Shared
import OperatinRuleUtils from 'shared/utils/operating_rules'
import { date as dateFormat } from 'shared/utils/format'
import moment, { localMomentInUTC } from 'shared/lib/moment'

export class TimeTable extends Component {
  static displayName = 'TimeTable'

  static propTypes = {
    id: PropTypes.string,
    date: PropTypes.any,
    onClose: PropTypes.func,
    fetchAvailability: PropTypes.func,
    quantity: PropTypes.number,
    selected: PropTypes.object,
    availabilities: PropTypes.object,
    showCounts: PropTypes.bool,
    width: PropTypes.number,
    t: PropTypes.func
  }

  constructor (props) {
    super(props)
    this.firstOpenElement = React.createRef()
  }

  componentDidMount = () => {
    const { date, fetchAvailability } = this.props

    fetchAvailability({
      time: date,
      timeTable: true
    })
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.availabilities !== prevProps.availabilities) {
      this.firstOpenElement?.current?.scrollIntoView()
    }
  }

  render () {
    const { availabilities, onClose, date, selected, showCounts, t } = this.props
    const localDate = localMomentInUTC(date)

    let firstOpenElement = availabilities.find((el) => el.inOpeningHours)

    return (
      <BTimeTable width={this.props.width}>
        <BTimeTable.Header>
          <Icon icon="arrow-left" onClick={onClose} />
          <P>{dateFormat(localDate, 'date')}</P>
        </BTimeTable.Header>
        <BTimeTable.ScrollContainer>
          {!availabilities && <Loader size="md" />}
          {availabilities.map((availability) => {
            let ref

            if (firstOpenElement === availability) {
              ref = this.firstOpenElement
            }

            const active = selected.contains(availability.time)

            return (
              <BTimeTable.Item
                key={availability.time}
                active={active}
                ref={ref}
                inOpeningHours={availability.inOpeningHours}
                data-time={dateFormat(availability.time, 'time')}
                data-active={String(active)}
              >
                <BTimeTable.Indicator className={availability.status} status={availability.status} />
                <P>{dateFormat(availability.time, 'time')}</P>
                {showCounts && (
                  <P>
                    {availability.quantity} {t('user.store.available')?.toLowerCase?.()}
                  </P>
                )}
                {!showCounts && (
                  <P>{t(availability.status === 'available' ? 'user.store.available' : 'user.store.unavailable')}</P>
                )}
              </BTimeTable.Item>
            )
          })}
        </BTimeTable.ScrollContainer>
      </BTimeTable>
    )
  }
}

const mapStateToProps = (_state, props) => {
  return {
    selected: moment.range(localMomentInUTC(props.selected.from), localMomentInUTC(props.selected.to)),
    availabilities: props.availabilities
      .getAll({
        type: 'time'
      })
      .map((el) => {
        const time = moment(`${el.date} ${el.hour}:${el.minute}`)

        return {
          time,
          date: el.date,
          status: el.status,
          quantity: el.quantity,
          inOpeningHours: OperatinRuleUtils.isWithinOpeningHours(time, props.operatingRules, true)
        }
      })
      .filter((el) => {
        // Note: In case we want to hide availability outside of opening hours
        // if (!el.inOpeningHours && el.status !== 'unavailable') return false
        const localDate = localMomentInUTC(props.date)
        return moment(el.date).isSame(localDate, 'day')
      })
      .sortBy((el) => el.time)
  }
}

const reduxComponent = reduxConnect(mapStateToProps)(TimeTable)

export default withTranslation('user')(reduxComponent)
